import type {
  StateFrom,
  InterpreterFrom,
  Prop,
  EventObject,
} from 'xstate';
import { RelatedSlidesOutput } from '@alucio/aws-beacon-amplify/src/models';
import type relatedSlideSM from './relatedSlide.machine';
import type { Typegen0 } from './relatedSlide.machine.typegen';
import { GenericError } from '../machineError';

export enum StateTags {
  LOADING = 'LOADING',
}

export type RelatedSlideState = StateFrom<typeof relatedSlideSM>
export type RelatedSlideService = InterpreterFrom<typeof relatedSlideSM>
export type RelatedSlideSend = Prop<RelatedSlideService, 'send'>
export type RelatedSlideMachine = typeof relatedSlideSM

export type RelatedSlideData = {
  pageId: string,
  score: number,
}

export type SMContext = {
  relatedSlides: Record<string, RelatedSlideData[]>,
  currentPageId?: string,
  error?: GenericError,
  retryAttempt: number,
}

export type SMServices = {
  fetchRelatedSlides: {
    data: RelatedSlidesOutput,
  },
}

export type SMContextKeys = keyof SMContext
export type StringStates = Extract<Typegen0['matchesStates'], string>

export type EvtValues<
  K extends T['type'],
  T extends EventObject = SMEvents
> = T extends { type: K }
  ? Omit<T, 'type'>
  : never

export type EVT_OPEN_RELATED_SLIDES_TAB = {
  type: 'OPEN_RELATED_SLIDES_TAB'
}

export type EVT_CLOSE_RELATED_SLIDES_TAB = {
  type: 'CLOSE_RELATED_SLIDES_TAB'
}

export type EVT_SWITCH_ONLINE = {
  type: 'SWITCH_ONLINE'
}

export type EVT_SWITCH_OFFLINE = {
  type: 'SWITCH_OFFLINE'
}

export type EVT_SWITCH_PAGE = {
  type: 'SWITCH_PAGE'
  currentPageId: string,
}

export type EVT_USER_RETRY = {
  type: 'USER_RETRY'
}

export type SMEvents =
  | EVT_OPEN_RELATED_SLIDES_TAB
  | EVT_CLOSE_RELATED_SLIDES_TAB
  | EVT_SWITCH_ONLINE
  | EVT_SWITCH_OFFLINE
  | EVT_SWITCH_PAGE
  | EVT_USER_RETRY
